import { Component } from 'react'
import { connect } from 'react-redux'
import { isIE } from '../../../cdl-react-components/utilities'
import { SITE_NAME } from '../../../../utilities/constants'
import { pushNotification } from '../../../../store/actions'

class UnsupportedBrowser extends Component {
    render() { return null }

    componentDidMount() {
        if(isIE())
            this.props.pushNotification(
                `We notice you are using an older web browser. 
                ${SITE_NAME} will work in your browser. However, you may experience minor issue while using this site. 
                We highly suggest moving to a modern browser such as <a href='https://www.google.ca/chrome/' target='_blank' rel='noreferrer'>Google Chrome</a> or 
                <a href='https://www.mozilla.org/en-US/firefox/' target='_blank' rel='noreferrer'>Mozilla Firefox</a> to get the best possible experience using ${SITE_NAME}`)
    }
}

const mapDispatchToProps = (dispatch) => ({
    pushNotification: (message, callback) => dispatch(pushNotification(message, callback))
})

export default connect(null, mapDispatchToProps)(UnsupportedBrowser)
